import React from "react";

const SearchApi = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2330_34)">
        <path
          d="M3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11Z"
          fill="#5F67E0"
        />
      </g>
      <path
        d="M10.0636 13.5684C8.29976 13.5684 6.87891 12.1031 6.87891 10.2842C6.87891 8.46526 8.29976 7 10.0636 7C11.8274 7 13.2483 8.46526 13.2483 10.2842C13.2483 12.1031 11.8274 13.5684 10.0636 13.5684ZM10.0636 7.50526C8.56923 7.50526 7.36886 8.74315 7.36886 10.2842C7.36886 11.8252 8.56923 13.0631 10.0636 13.0631C11.5579 13.0631 12.7583 11.8252 12.7583 10.2842C12.7583 8.74315 11.5579 7.50526 10.0636 7.50526Z"
        fill="white"
      />
      <path
        d="M12.4382 12.375L14.6381 14.6436L14.2917 15.0008L12.0918 12.7322L12.4382 12.375Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2330_34"
          x="0.625"
          y="0.625"
          width="20.75"
          height="20.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.1875" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2330_34"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2330_34"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SearchApi;
